import React, { useState } from "react";
import { Card, Typography, Form, Input, Button, Divider, theme, Avatar, App } from "antd";
import { MailOutlined, ArrowLeftOutlined, UserOutlined } from "@ant-design/icons";
import api from "../services/api";
import { Link, useNavigate } from "react-router";
import { useLanguage } from "../providers/LanguageProvider";

const { Title, Text } = Typography;

export default function ForgotPassword() {
  const { token } = theme.useToken();
  const { t } = useLanguage();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const message = App.useApp().message;

  const containerStyle = {
    minHeight: "100svh",
    display: "grid",
    placeItems: "center",
    padding: 24,
    background:
      token.isDark
        ? token.colorBgLayout
        : `linear-gradient(180deg, ${token.colorBgLayout} 0%, #fff 100%)`,
  };

  const cardStyle = {
    width: "100%",
    maxWidth: 480,
    borderRadius: 16,
    boxShadow:
      token.colorBgElevated === "#fff"
        ? "0 8px 30px rgba(0,0,0,0.06)"
        : "0 8px 30px rgba(0,0,0,0.25)",
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);
      await api.get("/auth/forgot-password", { params: { email: values.email } });
      message.success(t('FORGOT_SUCCESS_MESSAGE', 'Eğer bu e-posta adresi sistemimizde kayıtlı ise, sıfırlama bağlantısı e-posta adresinize gönderilmiştir.'));
      // Mesajın görünmesi için kısa bir gecikme
      setTimeout(() => {
        navigate("/login");
      }, 5000);
    } catch (err) {
      message.error(err?.response?.data?.message || t('FORGOT_ERROR_MESSAGE', 'İşlem başarısız. Lütfen tekrar deneyin.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={containerStyle}>
      <Card style={cardStyle} bodyStyle={{ padding: 28 }}>
        <div style={{ textAlign: "center", marginBottom: 12 }}>
          <Avatar size={72} icon={<UserOutlined />} style={{ background: token.colorPrimary, marginBottom: 8 }} />
        </div>

        <Title level={3} style={{ textAlign: "center", marginBottom: 6, fontWeight: 700 }}>
          {t('FORGOT_TITLE', 'Şifremi unuttum')}
        </Title>
        <Text type="secondary" style={{ display: "block", textAlign: "center" }}>
          {t('FORGOT_DESCRIPTION', 'E-posta adresinizi girin, sıfırlama bağlantısı gönderelim.')}
        </Text>

        <Form
          name="forgot-password"
          layout="vertical"
          autoComplete="off"
          requiredMark="optional"
          style={{ marginTop: 20 }}
          onFinish={onFinish}
        >
          <Form.Item
            label={t('LABEL_EMAIL', 'E-posta')}
            name="email"
            rules={[{ required: true, message: t('ERROR_EMAIL_REQUIRED', 'E-posta gerekli') }, { type: "email", message: t('ERROR_EMAIL_INVALID', 'Geçerli bir e-posta girin') }]}
          >
            <Input size="large" prefix={<MailOutlined />} placeholder={t('PLACEHOLDER_EMAIL', 'ornek@site.com')} inputMode="email" allowClear />
          </Form.Item>

          <Button type="primary" htmlType="submit" size="large" block loading={loading} aria-label={t('BTN_SEND_LINK', 'Bağlantı gönder')}>
            {t('BTN_SEND_LINK', 'Bağlantı gönder')}
          </Button>

          <Divider plain>{t('WORD_OR', 'veya')}</Divider>

          <Button size="large" icon={<ArrowLeftOutlined />} block onClick={() => navigate("/login")}>{t('BACK_TO_LOGIN', 'Giriş sayfasına dön')}</Button>
        </Form>
      </Card>
    </div>
  );
}


